'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var styles = require('@material-ui/core/styles');

var useStyles = styles.makeStyles(function (theme) {
    return styles.createStyles({
        popover: {
            pointerEvents: 'none',
        },
        paper: {
            padding: theme.spacing(1),
            backgroundColor: '#6D6D6D',
            color: 'white',
            fontFamily: theme.typography.fontFamily,
            fontSize: '15px',
        },
    });
});
var DisplayComponentsContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0px 5px;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0px 5px;\n"])));
var Container = styled__default.div(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  flex: 1;\n  width: 100%;\n"], ["\n  flex: 1;\n  width: 100%;\n"])));
var templateObject_1, templateObject_2;

exports.Container = Container;
exports.DisplayComponentsContainer = DisplayComponentsContainer;
exports.useStyles = useStyles;
